import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useContent } from "@/lib/queries";
import { Btn, Card, Overline } from "@/components/kit";
import { ArrowRight } from "lucide-react";

function Block({ b }) {
  if (b.type === "h") return <h2 className="font-serif text-2xl text-gold mt-8 mb-2">{b.text}</h2>;
  if (b.type === "quote")
    return <blockquote className="em-quote-rule my-6 font-serif text-2xl text-ink leading-snug">{b.text}</blockquote>;
  if (b.type === "list")
    return (
      <ul className="my-4 space-y-2">
        {b.items.map((it, i) => (
          <li key={i} className="flex gap-3 text-inksoft leading-relaxed">
            <span className="text-gold mt-1">·</span><span>{it}</span>
          </li>
        ))}
      </ul>
    );
  return <p className="text-inksoft leading-relaxed text-[17px] mt-4">{b.text}</p>;
}

export default function Reader() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: content } = useContent();
  if (!content) return <div className="text-inkfaint text-sm animate-pulse">Loading…</div>;

  const idx = content.chapters.findIndex((c) => c.slug === slug);
  const chapter = content.chapters[idx];
  if (!chapter) return <p className="text-inkfaint">Chapter not found.</p>;
  const next = content.chapters[idx + 1];

  return (
    <article className="max-w-2xl mx-auto em-fade-up" data-testid="reader-page">
      <Overline>Chapter {chapter.number}</Overline>
      <h1 className="font-serif text-4xl sm:text-5xl text-ink mt-2">{chapter.title}</h1>
      <p className="text-inkfaint mt-2">{chapter.subtitle}</p>
      <div className="text-xs text-faint mt-2 mb-6">{chapter.minutes} min read</div>
      <div>{chapter.blocks.map((b, i) => <Block key={i} b={b} />)}</div>

      <div className="mt-12">
        {next ? (
          <button onClick={() => navigate(`/read/${next.slug}`)} className="w-full text-left" data-testid="next-chapter">
            <Card className="flex items-center gap-4 hover:border-goldmuted/40 transition-colors">
              <div className="flex-1">
                <Overline>Next chapter</Overline>
                <div className="font-serif text-xl text-ink mt-1">{next.title}</div>
              </div>
              <ArrowRight className="w-5 h-5 text-inkfaint" />
            </Card>
          </button>
        ) : (
          <Btn variant="outline" className="w-full" onClick={() => navigate("/learn")} data-testid="back-to-framework">
            Back to the framework
          </Btn>
        )}
      </div>
    </article>
  );
}
